var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "J187MO.tif"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.269531 9.00035C0.269531 8.82035 0.269529 8.64036 0.329529 8.46036C0.491455 7.20456 1.04016 6.03027 1.89954 5.10036C2.87144 4.0242 4.18582 3.31755 5.61954 3.10036L6.23953 3.03035V0.360352L11.5396 4.68034L6.23953 9.01035V6.34035C6.03182 6.35323 5.82489 6.3766 5.61954 6.41035C4.3089 6.60436 3.09932 7.22672 2.17953 8.18034C1.68583 8.68344 1.28921 9.27332 1.00955 9.92035C0.789552 10.4503 0.559529 10.9204 0.329529 11.4904L0.269531 11.6203V9.00035Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8864ec6247dd62cdaf917cd112eca139.svg";
export { ForwardRef as ReactComponent };